"use client";

import { Skeleton } from "../Skeleton";

export interface SearchLoadingStateProps {
  /**
   * Number of skeleton items to show
   * @default 3
   */
  count?: number;
  /**
   * Additional CSS classes
   */
  className?: string;
}

/**
 * SearchLoadingState
 *
 * Loading state displayed while search results are being fetched.
 * Shows skeleton loaders that match the structure of search results.
 *
 * @example
 * ```tsx
 * <SearchLoadingState count={5} />
 * ```
 */
export function SearchLoadingState({ count = 3, className = "" }: SearchLoadingStateProps) {
  return (
    <div className={`flex flex-col ${className}`}>
      {Array.from({ length: count }).map((_, index) => (
        <div key={index} className="flex items-center gap-3 px-4 py-2.5">
          {/* Icon skeleton */}
          <Skeleton width={20} height={20} variant="circle" />

          {/* Content skeleton */}
          <div className="flex-1 min-w-0 space-y-2">
            <Skeleton width="60%" height={16} />
            <Skeleton width="40%" height={12} />
          </div>

          {/* Arrow skeleton */}
          <Skeleton width={16} height={16} />
        </div>
      ))}
    </div>
  );
}
